export const HOME_FEED_START_EVENT = "vivanomada:home-feed-start";

const HOME_FEED_START_PENDING_KEY = "vivanomada:home-feed-start-pending";

export const requestHomeFeedStart = () => {
  try {
    sessionStorage.setItem(HOME_FEED_START_PENDING_KEY, "true");
  } catch (error) {
    console.warn("Cannot store home feed navigation intent", error);
  }

  window.dispatchEvent(new CustomEvent(HOME_FEED_START_EVENT));
};

export const consumeHomeFeedStartRequest = () => {
  try {
    const shouldScroll =
      sessionStorage.getItem(HOME_FEED_START_PENDING_KEY) === "true";
    sessionStorage.removeItem(HOME_FEED_START_PENDING_KEY);
    return shouldScroll;
  } catch (error) {
    console.warn("Cannot read home feed navigation intent", error);
    return false;
  }
};

export const scrollHomeFeedToStart = ({ behavior = "smooth" } = {}) => {
  const target = document.querySelector(".home-content");

  if (target) {
    target.scrollIntoView({ behavior, block: "start" });
    return;
  }

  window.scrollTo({ top: 0, behavior });
};
